import { type SVGProps } from 'react';

export function Bell(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill="currentcolor"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.55 7.335c0 1.982.704 2.685 1.145 3.125.037.037.072.071.104.105a.616.616 0 01.201.438c.004.354-.29.666-.737.666H9.33c0 .748-.586 1.33-1.32 1.33-.754 0-1.34-.582-1.34-1.33H3.714c-.446 0-.714-.312-.714-.667 0-.145.045-.312.179-.437l.103-.105c.442-.44 1.147-1.143 1.147-3.125 0-1.605 1.205-2.897 2.857-3.23v-.438C7.286 3.313 7.598 3 8 3c.38 0 .692.313.692.667v.438c1.652.333 2.857 1.625 2.857 3.23zm-7.054 3.334c.468-.563 1.017-1.542 1.01-3.313v-.021C5.506 6.063 6.616 5 8 5c1.362 0 2.5 1.062 2.5 2.334l-.002.02c0 1.772.515 2.751.984 3.314H4.496z"
      ></path>
    </svg>
  );
}
